<template>
    <!-- 新增表格数据的dialog -->
    <div>
        <el-dialog :visible.sync="addDialogVisible" :close-on-click-modal="false" width="50%" 
        :before-close="handleToClose" title="新增服饰">
            <el-form ref="addForm" :model="addForm" :rules="rules"  label-width="80px" label-position="center">
                <el-row type="flex" class="row-bg" justify="space-around" :gutter="20">
                    <el-col :span="24">
                        <div class="grid-content bg-purple">
                            <el-form-item label="学校名称" prop="schoolName">
                                <el-input v-model="addForm.schoolName" placeholder="请输入学校名称"></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
                <!-- <el-row type="flex" class="row-bg" justify="space-around" :gutter="20">
                    <el-col :span="12">
                        <div class="grid-content bg-purple">
                            <el-form-item label="年度" prop="yearDate">
                                <el-date-picker
                                    v-model="addForm.yearDate"
                                    type="year"
                                    placeholder="选择年">
                                </el-date-picker>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <div class="grid-content bg-purple">
                            <el-form-item label="季度" prop="seasonType">
                                <el-input v-model="addForm.seasonType" placeholder="请输入季度"></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row> -->
                <!-- <el-row type="flex" class="row-bg" justify="space-around" :gutter="20">
                    <el-col :span="24">
                        <div>
                            <quillEditor
                                v-model="addForm.detailText"
                                ref="myQuillEditor"
                                class="editor ql-editor editReset"
                                id="editor"
                                :options="editorOption"
                                @change="onEditorChange($event)"
                                @keydown.native="onEditorKeyDown($event)"
                                @blur="onEditorblur()">
                            </quillEditor>
                        </div>
                    </el-col>
                </el-row> -->
                <el-row type="flex" justify="space-around" :gutter="20" :key="index">
                    <el-col :span="24">
                        <div class="grid-content bg-purple">
                            <el-form-item label="详情文件">
                                <el-upload
                                    class="avatar-uploader"
                                    action
                                    :on-success="handleAvatarSuccess"
                                    :http-request="(param) => handleHttpRequest(param,index)"
                                    :before-upload="beforeAvatarUpload">
                                    <el-button size="small" type="primary">点击上传</el-button>
                                    <div slot="tip" class="el-upload__tip">只能上传pdf文件</div>
                                </el-upload>
                            </el-form-item>
                            
                        </div>
                    </el-col>
                </el-row>

                <div class="dialog-footer">
                    <el-button type="info" @click="handleToClose">取 消</el-button>
                    <el-button type="primary" @click="submitForm('addForm')">保存</el-button>
                </div>
            </el-form>
        </el-dialog>
    </div>
</template>
<script>
import { quillEditor } from 'vue-quill-editor';
const titleConfig = [
    { Choice: '.ql-bold', title: '加粗' },
    { Choice: '.ql-italic', title: '斜体' },
    { Choice: '.ql-underline', title: '下划线' },
    { Choice: '.ql-header', title: '段落格式' },
    { Choice: '.ql-strike', title: '删除线' },
    { Choice: '.ql-blockquote', title: '块引用' },
    { Choice: '.ql-code', title: '插入代码' },
    { Choice: '.ql-code-block', title: '插入代码段' },
    { Choice: '.ql-font', title: '字体' },
    { Choice: '.ql-size', title: '字体大小' },
    { Choice: '.ql-list[value="ordered"]', title: '编号列表' },
    { Choice: '.ql-list[value="bullet"]', title: '项目列表' },
    { Choice: '.ql-direction', title: '文本方向' },
    { Choice: '.ql-header[value="1"]', title: 'h1标题' },
    { Choice: '.ql-header[value="2"]', title: 'h2标题' },
    { Choice: '.ql-align', title: '对齐方式' },
    { Choice: '.ql-color', title: '字体颜色' },
    { Choice: '.ql-background', title: '背景颜色' },
    { Choice: '.ql-image', title: '图像' },
    { Choice: '.ql-video', title: '视频' },
    { Choice: '.ql-link', title: '添加链接' },
    { Choice: '.ql-formula', title: '插入公式' },
    { Choice: '.ql-clean', title: '清除字体格式' },
    { Choice: '.ql-script[value="sub"]', title: '下标' },
    { Choice: '.ql-script[value="super"]', title: '上标' },
    { Choice: '.ql-indent[value="-1"]', title: '向左缩进' },
    { Choice: '.ql-indent[value="+1"]', title: '向右缩进' },
    { Choice: '.ql-header .ql-picker-label', title: '标题大小' },
    { Choice: '.ql-header .ql-picker-item[data-value="1"]', title: '标题一' },
    { Choice: '.ql-header .ql-picker-item[data-value="2"]', title: '标题二' },
    { Choice: '.ql-header .ql-picker-item[data-value="3"]', title: '标题三' },
    { Choice: '.ql-header .ql-picker-item[data-value="4"]', title: '标题四' },
    { Choice: '.ql-header .ql-picker-item[data-value="5"]', title: '标题五' },
    { Choice: '.ql-header .ql-picker-item[data-value="6"]', title: '标题六' },
    { Choice: '.ql-header .ql-picker-item:last-child', title: '标准' },
    { Choice: '.ql-size .ql-picker-item[data-value="small"]', title: '小号' },
    { Choice: '.ql-size .ql-picker-item[data-value="large"]', title: '大号' },
    { Choice: '.ql-size .ql-picker-item[data-value="huge"]', title: '超大号' },
    { Choice: '.ql-size .ql-picker-item:nth-child(2)', title: '标准' },
    { Choice: '.ql-align .ql-picker-item:first-child', title: '居左对齐' },
    {
        Choice: '.ql-align .ql-picker-item[data-value="center"]',
        title: '居中对齐'
    },
    {
        Choice: '.ql-align .ql-picker-item[data-value="right"]',
        title: '居右对齐'
    },
    {
        Choice: '.ql-align .ql-picker-item[data-value="justify"]',
        title: '两端对齐'
    }
];
export default {
    data() {
        return {
            imageUrl: '',
            uploadUrl: 'file/upload', //图片上传地址
            dialogImageUrl: '',
            dialogVisible: false,
            addDialogVisible: false,
            addForm: {
                schoolName: '',
                seasonType: '',
                yearDate: '',
                fileUrl: '',
                fileId: '',
            },
            clothesPicUid: [],
            clothesSizeIds: [],
            clothesZone: [],
            rules:{},
            editorOption: {
                theme: 'snow',
                modules: {
                    toolbar: {
                        container: [
                            ['bold', 'italic', 'underline', 'strike'], // 加粗，斜体，下划线，删除线
                            ['blockquote', 'code-block'], // 引用，代码块
                            [{ header: 1 }, { header: 2 }], // 标题，键值对的形式；1、2表示字体大小
                            [{ list: 'ordered' }, { list: 'bullet' }], // 列表
                            [{ script: 'sub' }, { script: 'super' }], // 上下标
                            [{ indent: '-1' }, { indent: '+1' }], // 缩进
                            [{ direction: 'rtl' }], // 文本方向
                            [{ size: ['small', false, 'large', 'huge'] }], // 字体大小
                            [{ header: [1, 2, 3, 4, 5, 6, false] }], // 几级标题
                            [{ color: [] }, { background: [] }], // 字体颜色，字体背景颜色
                            [{ font: [] }], // 字体
                            [{ align: [] }], // 对齐方式
                            ['clean'], // 清除字体样式
                            ['image', 'video']
                        ],
                        handlers: {
                            image: function(value) {
                                if (value) {
                                    // alert(1);
                                    // 用upload的点击事件代替文本编辑器的图片上传事件
                                    document.querySelector('.avatar-uploaders input').click();
                                } else {
                                    this.quill.format('image', false);
                                }
                            }
                        }
                    }
                }
            },
        }
    },
    props: [],
    components: {
        quillEditor
    },
    methods: {
        openDialog() {
            this.addDialogVisible = true;
        },
        submitForm() {
            let that = this;
            that.$refs.addForm.validate(valid => {
                if (valid) {
                    this.$axios
                        .post('manage/cloth/saveClothesSchool', {
                            schoolName: that.addForm.schoolName,
                            yearDate: that.addForm.yearDate, 
                            seasonType: that.addForm.seasonType, 
                            detailText: that.addForm.detailText,
                            fileUrl: that.addForm.fileUrl,
                            fileId: that.addForm.fileId
                        })
                        .then(res => {
                            if (res.data.code == 0) {
                                //新增成功后 置空表单数据 关闭弹窗  刷新列表
                                that.$message.success('新增成功');
                                that.addDialogVisible = false;
                                that.resetForm();
                                that.$emit('getClothesSchoolList');
                            } else {
                                that.$message.error(res.data.data);
                            }
                        });
                } else {
                    // console.log('error submit!!');
                    return false;
                }
            });
        },
        resetForm() {
            this.$refs.addForm.resetFields();
            this.dialogImageUrl = '';
            this.clothesPicUid = [];
            this.dialogVisible = false;
            this.$refs.detailPic.clearFiles()
        },
        handleToClose() {
            let that = this;
            that.$confirm('确认放弃对当前页面信息的保存吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    that.addDialogVisible = false;
                    this.resetForm();
                })
                .catch(() => {});
            // 重置表单
        },
        getCurVal(val) {
            this.addForm.clothesMaterial = val.target.value;
        },
        handleAvatarSuccess(res, file) {
        },
        beforeAvatarUpload(file) { 
        },
        //上传事件
        async handleHttpRequest(param,index) {
            const formData = new FormData();
            formData.append('file', param.file);
            let config = {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            };
            const res = await this.$axios.post(this.uploadUrl, formData, config);
            if (res.data.code == 0) {
                console.log(res.data);
                this.addForm.fileUrl = res.data.data.url
                this.addForm.fileId = res.data.data.id
                console.log(this.addForm);
            } else {
            }
        },
        handleRemove(file, fileList) {
        },
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        onEditorChange({ editor, html, text }) {},
        onEditorKeyDown(event) {},
        handleRemove(file, fileList) {},
        handleAvatarSuccess() {},
    }
}
</script>

<style lang="less" scoped>
.dialog-footer {
    text-align: right;
}
.el-select {
    width: 100%;
}
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}
.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 148px;
    height: 148px;
    line-height: 148px;
    text-align: center;
    border: 1px dashed #d9d9d9;
}
.avatar {
    width: 148px;
    height: 148px;
    display: block;
}
.mr-b {
    margin-bottom: 20px;
}

</style>
